function HierarchyNode({ node, depth = 0 }) {
  const icons = ["🗂️", "📦", "📋", "🚚", "📈", "📊", "🔁"];
  const icon = icons[depth % icons.length];
 
  return (
<div style={{ marginLeft: depth === 0 ? 0 : 20 }}>
<div className="flex items-center gap-2 py-1">
<span className="text-sm">{icon}</span>
<span className={`text-sm ${depth === 0 ? "font-semibold text-gray-800" : "text-gray-700"}`}>
          {node.label}
</span>
        {node.meta?.badge && (
<span className="text-xs px-2 py-0.5 rounded-full bg-gray-100 text-gray-500 font-medium">
            {node.meta.badge}
</span>
        )}
</div>
 
      {node.children?.length > 0 && (
<div className="border-l border-gray-200 ml-[9px] pl-3">
          {node.children.map((child, i) => (
<HierarchyNode key={i} node={child} depth={depth + 1} />
          ))}
</div>
      )}
</div>
  );
}
 
export default function HierarchyResponse({ data }) {
  if (!data?.root) return null;
  return (
<div className="mt-2 w-full">
<HierarchyNode node={data.root} depth={0} />
</div>
  );
}